var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.462 16.97H3.536a2.373 2.373 0 01-2.368-2.37V7.5c0-.732.346-1.435.928-1.88l5.467-4.135a2.37 2.37 0 012.878.004l5.46 4.128c.585.448.931 1.15.931 1.883v7.103a2.375 2.375 0 01-2.37 2.368zM8.997 2.454a.913.913 0 00-.557.188L2.975 6.775a.924.924 0 00-.356.725v7.103c0 .506.412.916.917.916H14.46a.92.92 0 00.917-.916V7.5a.918.918 0 00-.36-.727L9.559 2.645a.912.912 0 00-.56-.192z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.244 13.453H6.756a.727.727 0 010-1.453h4.488a.727.727 0 010 1.453z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
export default SvgHomepage;